
const CartSummaryLine = ({type, price, bold}) => {

    return (
        <div className={"cart-summary-line" + (bold ? " b" : "")}>
            <p className="cart-summary-item">{type}</p>
            <p className="cart-summary-price">{price}</p>
        </div>
    )
}

export default CartSummaryLine;
